import { useSelector } from "react-redux";
import { selectToolName } from "../slices/footer/footerSlice";

const ToolNameDisplay = ({ toolName }) => {
    if (toolName.includes("®")) {
        let toolNameSplit = toolName.split("®");
        return <>{toolNameSplit[0]}<sup style={{
            verticalAlign: "super",
            fontSize: "x-small"
        }}>®</sup>{toolNameSplit[1]}</>
    }
    return <>{toolName}</>
}

const PageTitle = ({ }) => {
    const toolName = useSelector(selectToolName);
    return <>
        {
            (toolName && toolName !== "FEvIR® Platform") &&
            <h2 style={{
                width: "100%", textAlign: "center", marginTop: "8px",
                color: "#AC3B61"
            }}>
                <ToolNameDisplay toolName={toolName} />
            </h2>
        }
    </>
}
export default PageTitle;